import { useEffect, useState } from "react";
import MetereologicalService from "../domain/Metereological/MetereologicalService";
import { Metereological } from "@/domain/Metereological/Metereological";

const metereologicalService = new MetereologicalService();

export default function useMetereological() {
  const [meterelogicals, setMeterelogicals] = useState<Metereological[]>([]);

  async function handleGetMetereological() {
    const response = await metereologicalService.getMeteorologicalInfo();
    setMeterelogicals(response);
  }

  useEffect(() => {
    handleGetMetereological();
  }, []);

  return { meterelogicals };
}
